import { InputIuguCreditCard } from "@scrile/api-provider/dist/api/IuguPurchaseProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { PurchaseSubjectTypeEnum } from "@scrile/api-provider/dist/api/PurchaseTypeProvider";
import { RecurringBillingScheduleSubjectTypeEnum } from "@scrile/api-provider/dist/api/RecurringBillingScheduleProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { Subscription } from "@scrile/api-provider/dist/api/SubscriptionProvider";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import providers from "@/lib/api";
import config from "@/config";
import paymentComponent from "./Iugu.vue";
import { IntegrationModule } from "../types";

interface PaymentData {
  billingDetails: InputIuguCreditCard;
  type?: string;
  subscriptionSubject?: Subject<RecurringBillingScheduleSubjectTypeEnum>;
  purchaseSubject?: Subject<PurchaseSubjectTypeEnum>;
}

const module: IntegrationModule<PaymentData | undefined> = {
  paymentComponent,
  purchase: async (data, paymentData) => {
    const subjectPurchased = !!paymentData?.purchaseSubject;
    if (paymentData?.type === "creditCard") {
      providers.IuguPurchaseProvider.setTestMode(config.featureIuguPaymentSystem === "testMode");
      const transaction: Transaction = await providers.IuguPurchaseProvider.purchaseDeposit({
        data: { ...data, billingDetails: paymentData?.billingDetails, subject: paymentData?.purchaseSubject },
      });
      return {
        status: true,
        subjectPurchased,
        transaction,
      };
    }
    if (["pix", "boleto"].includes(paymentData?.type ?? "")) {
      return {
        status: true,
        subjectPurchased,
        transaction: undefined,
      };
    }
    return {
      status: false,
      subjectPurchased: false,
      transaction: undefined,
    };
  },
  subscribe: async (data, paymentData) => {
    const subjectPurchased = !!paymentData?.purchaseSubject;
    if (paymentData?.type === "creditCard" && paymentData?.subscriptionSubject) {
      providers.IuguPurchaseProvider.setTestMode(config.featureIuguPaymentSystem === "testMode");
      const subscription: Subscription = await providers.IuguPurchaseProvider.purchaseRecurring({
        data: {
          ...data,
          billingDetails: paymentData?.billingDetails,
          subject: paymentData?.subscriptionSubject,
        },
      });
      return {
        status: true,
        subjectPurchased,
        subscription,
      };
    }
    if (["pix", "boleto"].includes(paymentData?.type ?? "")) {
      return {
        status: true,
        subjectPurchased,
        subscription: undefined,
      };
    }
    return {
      status: false,
      subjectPurchased: false,
      subscription: undefined,
    };
  },
  allowSaveCard: true,
  forceShowUI: true,
};

export const selector = (system: PaymentSystemPublic | null): boolean => {
  return system?.type === "iugu" ?? false;
};

export default module;
